// test770
(770 && 0);
